import { Button } from '../ui/button';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { FileSpreadsheet, Upload, Loader2, ArrowRight, X } from 'lucide-react';

export function ImportUploadStep({ selectedFile, onFileSelect, onClearFile, onCancel, onValidate, validating }) {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <FileSpreadsheet className="w-16 h-16 mx-auto text-primary/60 mb-4" />
        <h3 className="text-lg font-semibold mb-2">Carica file Excel</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Seleziona un file .xlsx con gli articoli da importare o aggiornare
        </p>
      </div>

      <div className="border-2 border-dashed rounded-lg p-8 text-center hover:border-primary/50 transition-colors">
        <input
          type="file"
          accept=".xlsx"
          onChange={onFileSelect}
          className="hidden"
          id="excel-upload"
          data-testid="excel-upload-input"
        />
        <label
          htmlFor="excel-upload"
          className="cursor-pointer block"
        >
          <Upload className="w-10 h-10 mx-auto text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground">
            Clicca per selezionare o trascina il file qui
          </p>
        </label>
      </div>

      {selectedFile && (
        <Alert className="bg-primary/5 border-primary/20">
          <FileSpreadsheet className="h-4 w-4" />
          <AlertTitle>File selezionato</AlertTitle>
          <AlertDescription className="flex items-center justify-between">
            <span>{selectedFile.name}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFile}
            >
              <X className="w-4 h-4" />
            </Button>
          </AlertDescription>
        </Alert>
      )}

      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={onCancel}>
          Annulla
        </Button>
        <Button
          onClick={onValidate}
          disabled={!selectedFile || validating}
          data-testid="validate-excel-btn"
        >
          {validating ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Validazione...
            </>
          ) : (
            <>
              Valida file
              <ArrowRight className="w-4 h-4 ml-2" />
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
